<ion-item button class="compact" lines="none" detail="false" (click)="openDropDown($event)">
    <ion-icon *ngIf="!autoOpen" slot="start" name="chevron-down-outline"></ion-icon>
    <ion-label *ngIf="!inline && fullName" class="fullWidth compactlabel" position="{{labelPosition}}">
        {{ translationPrefix + '.category.name' | translate}}
    </ion-label>
    <ion-item button class="compact inner" lines="none" detail="false">
        <ion-label *ngIf="!fullName" class="search-all">
            {{ translationPrefix + '.category.all' | translate}}
        </ion-label>
        <ion-label *ngIf="fullName" class="fullWidth labelSmallMargin" text-wrap>
            {{fullName}}
        </ion-label>
        <ion-icon *ngIf="!inline && fullName" name="close" (click)="clearCategory($event)">
        </ion-icon>
    </ion-item>
</ion-item>
